import axios from "axios";
import http from "./Endpoint";

class PreorderService {

  projection = {
    "order_by": {
      "name": "ASC"
    },
    "limit": 100,
    "offset": 0
  }

  /**
   * List order for a user
   * @param {*} filter 
   * {
   *  "customer_id": 1850,
   *  "user_id": 0,
   * }
   */
  list(filter) {
    return http().post("/preorder/list", filter);
  }

  /**
   * Get details for an order
   * @param int orderId 
   * @returns 
   */
  query(preorderId) {
    let article = {
      "filter": { "id": preorderId },
      "return": [
        "id",
        "customer_id",
        "customer_name",
        "user_id",
        "user_name",
        "order_status_name",
        "order_type_name",
        "delivery_method_name",
        "payment_method_name",
        "order_type_name",
        "created",
        "order_products",
        "shipping_address"
      ]
    }
    return http().post("/preorder/query", article);
  }

  /**
   * Simple way of placing order
   * @param {*} article 
   * 
   *{
   * }
   * @returns 
   */
  add(data) {
    return http().post("/preorder/add", data);
  }

  confirmEmail(data) {
    return http().post("/preorder/confirmEmail", data);
  };

  approve(data) {
    return http().post("/preorder/approve", data);
  }

}

export default new PreorderService();